import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Reference from "../store/ducks/reference.duck";
import * as Admin from "../store/ducks/admin.duck";
import { Scheduler, WeekView, MonthView, DayView, SchedulerItem, SchedulerItemContent } from "@progress/kendo-react-scheduler";
// import { Modal } from "react-bootstrap";
import { FormWithCustomEditor } from "./scheduler/custom-form";
import { IntlProvider, load, loadMessages, LocalizationProvider } from "@progress/kendo-react-intl";
import { guid } from "@progress/kendo-react-common";
import { Modal, Button, Form } from "react-bootstrap";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import numbers from "cldr-numbers-full/main/en-AU/numbers.json";
import currencies from "cldr-numbers-full/main/en-AU/currencies.json";
import caGregorian from "cldr-dates-full/main/en-AU/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/en-AU/dateFields.json";
import { Day } from "@progress/kendo-date-math";
import { parseISO, differenceInMinutes } from "date-fns";
import PhoneIcon from "@material-ui/icons/Phone";
import BookingOutcome from "./BookingOutcome";
import { ToastContainer, Flip } from "react-toastify";
import { Grid, Checkbox } from "@material-ui/core";
import { format } from "date-fns";

import "../../_metronic/_assets/css/app2.css";
import { bookingLocation } from "./scheduler/data";

load(likelySubtags, currencyData, weekData, numbers, currencies, caGregorian, dateFields);

const displayDate = new Date();

export default function AvailabilityNew({ mainID, fullName, userTZ, providerType, currentFundingTypes }) {
  const dispatch = useDispatch();
  // const registered = useSelector(state => state.admin.RegisteredPsychologists[0]);
  const bookings = useSelector((state) => state.admin.ProviderBookings);
  const availability = useSelector((state) => state.admin.Availability);
  const clients = useSelector((state) => state.admin.Clients);
  const [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  const [attendanceData, setAttendanceData] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [cancelBookingData, setCancelBookingData] = useState(null);
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);
  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [booking, setBooking] = useState(null);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const schedulerMessages = {
    "scheduler.deleteConfirmation": "Are you sure you want to cancel this booking?",
    "scheduler.editorDelete": "Cancel Booking",
    "scheduler.deleteTitle": "Cancel",
    "scheduler.deleteDialogTitle": "Cancel Booking",
  };

  loadMessages(schedulerMessages, "en-AU");

  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchConstants());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchFundingTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchBookingTypeStatistics());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchClients({ status: "Active", providerId: mainID, type: providerType }));
  }, [dispatch, mainID, providerType]);

  useEffect(() => {
    if (mainID) {
      dispatch(Admin.actions.fetchBookings({ key: "psychologist", id: mainID }));
      dispatch(Admin.actions.fetchAvailability({ psychologistid: mainID, userTZ }));
    }
  }, [dispatch, mainID, userTZ]);

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (cancellationType === "NoShow") {
      // Update database as client did not show
      dispatch(
        Admin.actions.putAppointment({
          id: id,
          status: "NoShow",
          cancellationReason: cancellationReason,
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
      // Update local display
      setBooking({ ...booking, status: "NoShow" });
      if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
        const formData = new FormData();
        formData.append("type", "Client");
        formData.append("pkid", booking.clientID);
        formData.append("subject", "");
        formData.append("selector", "SMS");
        formData.append("note", cancellationTypeSMSText);
        formData.append("faxdestination", "");
        formData.append("faxFile", "");
        formData.append("sendFormID", 0);
        // Ok Time to Dispatch
        process.env.REACT_APP_DEBUG && console.log(...formData);
        dispatch(
          Admin.actions.postNote({
            formData: formData,
            type: "Client",
            pkID: booking.clientID,
          }),
        );
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: "psychologist", id: mainID },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: mainID },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database as booking cancelled by provider
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: mainID },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
  }

  const LEGEND_ITEMS = [
    {
      label: "Availability - Existing Clients",
      striped: true,
      color1: "#575ec2",
      color2: "#0000FF",
    },
    {
      label: "Availability - New Medicare Clients",
      color: "#0000FF",
    },
    {
      label: "Unavailable",
      color: "#800080",
    },
    {
      label: "Availability - Supervision",
      color: "#808080",
    },
    {
      label: "Availability - Contract",
      color: "#21B6A8",
    },
    {
      label: "Availability - Contract New Clients",
      color: "#CDB199",
    },
    {
      label: "Availability - Contract Existing Clients",
      color: "#189AB4",
    },
    {
      label: "Availability - Peri Natal Grief/Loss",
      color: "#E1C340",
    },
    {
      label: "Availability - NthQLDPHN New Clients",
      color: "#D3B1C2",
    },
    {
      label: "Availability - NthQLDPHN Existing Clients",
      color: "#C197D2",
    },
    {
      label: "Availability - NthQLDPHN Face to Face",
      color: "#f6c324",
    },
    {
      label: "Availability - Centralised Service",
      color: "#0d413e",
    },
    {
      label: "Availability - Centralised Service and Medicare New Clients",
      color: "#0d413e",
    },
    {
      label: "Availability - Centralised Service Secondary Case Conference",
      color: "#0d413e",
    },
    {
      label: "Booking - Provisional",
      color: "#FFC0CB",
    },
    {
      label: "Booking - Bulk Billed",
      color: "#133b0a",
    },
    {
      label: "Booking - NDIS",
      color: "#672771",
    },
    {
      label: "Booking - Reduced Gap",
      color: "#6acccc",
    },
    {
      label: "Booking - Contract",
      color: "#256A87",
    },
    {
      label: "Booking - EAP",
      color: "#FFC5D0",
    },
    {
      label: "Booking - Full Fee",
      color: "#cfb94a",
    },
    {
      label: "Booking - TAC",
      color: "#f6c324",
    },
    {
      label: "Booking - WorkCover",
      color: "#f6c324",
    },
    {
      label: "Booking - DVA",
      color: "#f6c324",
    },
    {
      label: "Booking - Island",
      color: "#6acccc",
    },
  ];

  const availabilityItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Availability") || x.label === "Unavailable");

  const bookingItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Booking"));

  const LegendItem = ({ item }) => {
    const swatchStyle = item.striped
      ? {
          background: `repeating-linear-gradient(
          45deg,
          ${item.color1},
          ${item.color1} 10px,
          ${item.color2} 10px,
          ${item.color2} 20px
        )`,
        }
      : {
          backgroundColor: item.color,
        };

    return (
      <div className="scheduler-legend-item">
        <span className="scheduler-legend-swatch" style={swatchStyle} />
        <span>{item.label}</span>
      </div>
    );
  };

  const SchedulerLegend = () => {
    return (
      <div className="scheduler-legend">
        <div className="scheduler-legend-title">Calendar Legend</div>

        <div className="scheduler-legend-sections">
          {/* AVAILABILITY */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Availability</div>

            <div className="scheduler-legend-grid">
              {availabilityItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>

          {/* BOOKINGS */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Bookings</div>

            <div className="scheduler-legend-grid">
              {bookingItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const SchedulerLegendContainer = () => {
    const [showLegend, setShowLegend] = useState(false);

    return (
      <div className="scheduler-legend-container">
        <div className="scheduler-legend-toolbar">
          <button type="button" className="scheduler-legend-button" onClick={() => setShowLegend(!showLegend)}>
            {showLegend ? "Hide Legend" : "Show Legend"}
          </button>
        </div>

        {showLegend && (
          <div className="scheduler-legend-panel">
            <SchedulerLegend />
          </div>
        )}
      </div>
    );
  };

  // Assemble data from bookings and availability
  const newBookings = bookings
    .filter((r) => r.status !== "Cancelled" && r.status !== "LateCancelProvider")
    .map((row) => {
      return {
        id: row.id,
        clientID: row.clientID,
        eventType: "booking",
        title: row.clientfullname,
        start: parseISO(row.startDate),
        end: parseISO(row.endDate),
        note: row.note,
        paymentType: row.paymentType,
        bookingType: row.bookingType,
        bookingCode: row.bookingCode,
        bookingLocation: row.bookingLocation,
        status: row.status,
        contactMobilePhone: row.contactMobilePhone,
        showTodoIcon: row.toDoCount !== 0 ? true : false,
        appointmenttype: row.appointmenttype,
        contractId: row.contractId,
        days: row.days,
        bulkBillingFormStatus: row.bulkBillingFormStatus,
      };
    });

  const newAvailability = availability.map((row) => {
    //
    // Handle change of availabilityType for Display (i.e. Any = All)
    let availabilityTypeDisplay = "Available - New MedicareClient Bookings";
    if (
      row.availabilityType !== "Any" &&
      row.availabilityType !== "New Client Bookings" &&
      row.availabilityType !== "Other" &&
      row.availabilityType !== "NDISContractEAP" &&
      row.availabilityType !== "NDISContractEAPNew" &&
      row.availabilityType !== "NDISContractEAPExisting" &&
      row.availabilityType !== "EAPIsland" &&
      row.availabilityType !== "PerinatalGriefLoss" &&
      row.availabilityType !== "NthQLDPHNNew" &&
      row.availabilityType !== "NthQLDPHNExisting" &&
      row.availabilityType !== "NthQLDPHNFacetoFace" &&
      row.availabilityType !== "CentralisedService"
    ) {
      availabilityTypeDisplay = "Available - Existing";
    }
    if (row.availabilityType === "Other") {
      availabilityTypeDisplay = "Other (Not Available)";
    }
    if (row.availabilityType === "Supervision") {
      availabilityTypeDisplay = "Available - Supervision";
    }
    if (row.availabilityType === "NDISContractEAP") {
      availabilityTypeDisplay = "Available - NDIS/Contract";
    }
    if (row.availabilityType === "NDISContractEAPNew") {
      availabilityTypeDisplay = "Available - New Client or NDIS/Contract";
    }
    if (row.availabilityType === "NDISContractEAPExisting") {
      availabilityTypeDisplay = "Available - Existing Client or NDIS/Contract";
    }
    if (row.availabilityType === "EAPIsland") {
      availabilityTypeDisplay = "Available - EAP/Island";
    }
    if (row.availabilityType === "PerinatalGriefLoss") {
      availabilityTypeDisplay = "Available - Perinatal Grief & Loss";
    }
    if (row.availabilityType === "NthQLDPHNNew") {
      availabilityTypeDisplay = "Available - Nth QLD PHN New Clients";
    }
    if (row.availabilityType === "NthQLDPHNExisting") {
      availabilityTypeDisplay = "Available - Nth QLD PHN Existing Clients";
    }
    if (row.availabilityType === "NthQLDPHNFacetoFace") {
      availabilityTypeDisplay = "Available - Nth QLD PHN Face to Face Clients";
    }
    if (row.availabilityType === "CentralisedService") {
      availabilityTypeDisplay = "Available - Centralised Service";
    }
    if (row.availabilityType === "CentralisedServiceMedicareNew") {
      availabilityTypeDisplay = "Available - Centralised Service and Medicare New Clients";
    }
    if (row.availabilityType === "CentralisedServiceSecondaryCaseConference") {
      availabilityTypeDisplay = "Available - Centralised Service Secondary Case Conference";
    }
    return {
      id: row.id,
      availabiltyType: row.availabilityType,
      eventType: "availability" + row.availabilityType,
      psychologistID: row.psychologistID,
      availabilityType: row.availabilityType,
      title: availabilityTypeDisplay,
      start: parseISO(row.startDate),
      end: parseISO(row.endDate),
      recurrenceRule: row.rRule && row.rRule.length > 0 ? row.rRule.replace("RRULE:", "") : undefined,
      recurrenceExceptions: row.exDate.length > 0 ? row.exDate.split(",").map((item) => (item.length === 16 ? parseISO(item) : new Date(item))) : [],
    };
  });

  const items = React.useMemo(() => {
    return [...newBookings, ...newAvailability];
  }, [bookings, availability]);

  // create ref to vars we need to submit with actions, so we can fetch the vales after they have been set by useEffect
  const payloadParams = {
    psychologistID: mainID,
    userTZ: userTZ,
  };

  const payloadRef = useRef(payloadParams);
  useEffect(() => {
    payloadRef.current = payloadParams;
  }, [payloadParams]);

  // Custom item to apply colour for bookings/paymentType vs. availability
  const CustomItem = (props) => {
    var backgroundStyles = { backgroundColor: "blue" };
    switch (props.dataItem.eventType) {
      case "availability":
        backgroundStyles = { backgroundColor: "blue" };
        break;
      case "availabilityExisting":
        backgroundStyles = {
          background: "repeating-linear-gradient(45deg, #575ec2, #575ec2 10px, blue 10px, blue 20px)",
        };
        break;
      case "availabilityAny":
        backgroundStyles = { backgroundColor: "#0000FF" };
        break;
      case "availabilityOther":
        backgroundStyles = { backgroundColor: "#800080" };
        break;
      case "availabilitySupervision":
        backgroundStyles = { backgroundColor: "#808080" };
        break;
      case "availabilityNDISContractEAP":
        backgroundStyles = { backgroundColor: "#21B6A8" };
        break;
      case "availabilityNDISContractEAPNew":
        backgroundStyles = { backgroundColor: "#CDB199" };
        break;
      case "availabilityNDISContractEAPExisting":
        backgroundStyles = { backgroundColor: "#189AB4" };
        break;
      case "availabilityEAPIsland":
        backgroundStyles = { backgroundColor: "#189AB4" };
        break;
      case "availabilityPerinatalGriefLoss":
        backgroundStyles = { backgroundColor: "#E1C340" };
        break;
      case "availabilityNthQLDPHNNew":
        backgroundStyles = { backgroundColor: "#D3B1C2" };
        break;
      case "availabilityNthQLDPHNExisting":
        backgroundStyles = { backgroundColor: "#C197D2" };
        break;
      case "availabilityNthQLDPHNFacetoFace":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "availabilityCentralisedService":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      case "availabilityCentralisedServiceMedicareNew":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      case "availabilityCentralisedServiceSecondaryCaseConference":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      default:
        backgroundStyles = { backgroundColor: "#0000FF" };
    }
    switch (props.dataItem.paymentType) {
      case "Provisional":
        backgroundStyles = { backgroundColor: "#FFC0CB" };
        break;
      case "Bulk Billed":
        backgroundStyles = { backgroundColor: "#133b0a" };
        break;
      case "NDIS":
        backgroundStyles = { backgroundColor: "#672771" };
        break;
      case "Reduced Gap":
        backgroundStyles = { backgroundColor: "#6acccc" };
        break;
      case "Contract":
        backgroundStyles = { backgroundColor: "#256A87" };
        break;
      case "EAP":
        backgroundStyles = { backgroundColor: "#FFC5D0" };
        break;
      case "Full Fee":
        backgroundStyles = { backgroundColor: "#cfb94a" };
        break;
      case "TAC":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "WorkCover":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "DVA":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      default:
        break;
    }

    var customStyles = { ...backgroundStyles, fontSize: 12 };

    return (
      <SchedulerItem {...props} style={{ ...props.style, ...customStyles }}>
        {props.children}
        {props.dataItem.eventType === "booking" && props.dataItem.appointmenttype === "1" ? (
          <SchedulerItemContent>
            <PhoneIcon />
          </SchedulerItemContent>
        ) : null}
      </SchedulerItem>
    );
  };

  // We manage both local state and redux state, to make the UI more responsive and not wait for redux.
  // data = local state, updated directly by change events - the calendar displays from this array
  // items = redux state, updated via actions. We only update local from this once the items != prevItems (i.e. redux has changed)
  // So, the sequence is update => update data => send action => items get updated from redux => is now different to prevItems => update data (again) with fresh copy from items
  const [data, setData] = React.useState([]);

  useEffect(() => {
    setData(items);
  }, [items]);

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const getUpdateTitle = (item) => {
    switch (item.eventType) {
      case "availability":
        return "Availability";
      case "availabilityAny":
        return "Availability - New Client (Medicare) Bookings";
      case "availabilityOther":
        return "Availability - Other (Not Available)";
      case "availabilityExisting":
        return "Availability - Existing (Medicare)";
      case "availabilitySupervision":
        return "Availability - Supervision";
      case "availabilityNDISContractEAP":
        return "Availability - NDIS/Contract";
      case "availabilityNDISContractEAPNew":
        return "Availability - New Client or NDIS/Contract";
      case "availabilityEAPIsland":
        return "Availability - EAP/Island";
      case "availabilityNDISContractEAPExisting":
        return "Availability - Existing Client or NDIS/Contract";
      case "availabilityPerinatalGriefLoss":
        return "Availability - Perinatal Grief & Loss";
      case "availabilityNthQLDPHNNew":
        return "Availability - Nth QLD PHN New";
      case "availabilityNthQLDPHNExisting":
        return "Availability - Nth QLD PHN Existing";
      case "availabilityNthQLDPHNFacetoFace":
        return "Availability - Nth QLD PHN Face to Face Clients";
      case "availabilityCentralisedService":
        return "Availability - Centralised Service";
      case "availabilityCentralisedServiceMedicareNew":
        return "Availability - Centralised Service and Medicare New Clients";
      case "availabilityCentralisedServiceSecondaryCaseConference":
        return "Availability - Centralised Service Secondary Case Conference";
      default:
        return clients.find((row) => row.id === parseInt(item.clientID)).fullname;
    }
  };
  const handleDataChange = (props) => {
    setData((old) =>
      old
        .filter(
          (item) =>
            props.deleted.find((current) => current.id === item.id) === undefined &&
            props.updated.find((current) => current.id === item.id && current.status === "Cancelled") === undefined,
        )
        .map((item) => props.updated.find((current) => current.id === item.id) || item)
        .concat(
          props.created.map((item) =>
            Object.assign({}, item, {
              id: guid(),
              title: getUpdateTitle(item), // get the proper title to display (e.g. client fullname for bookings)
            }),
          ),
        ),
    );
    var payload = {};
    var duration = 0;
    // Updated
    if (props.updated.length > 0) {
      var changed = props.updated[0];
      // console.log(changed.eventType);
      if (
        changed.eventType === "availability" ||
        changed.eventType === "availabilityAny" ||
        changed.eventType === "availabilityExisting" ||
        changed.eventType === "availabilityOther" ||
        changed.eventType === "availabilitySupervision" ||
        changed.eventType === "availabilityNDISContractEAP" ||
        changed.eventType === "availabilityNDISContractEAPNew" ||
        changed.eventType === "availabilityNDISContractEAPExisting" ||
        changed.eventType === "availabilityPerinatalGriefLoss" ||
        changed.eventType === "availabilityNthQLDPHNNew" ||
        changed.eventType === "availabilityNthQLDPHNExisting" ||
        changed.eventType === "availabilityNthQLDPHNFacetoFace" ||
        changed.eventType === "availabilityCentralisedService" ||
        changed.eventType === "availabilityCentralisedServiceMedicareNew" ||
        changed.eventType === "availabilityCentralisedServiceSecondaryCaseConference" ||
        changed.eventType === "availabilityEAPIsland"
      ) {
        payload = {
          slot: changed.id,
          id: changed.id,
          mainID: changed.psychologistID,
          startDate: changed.start,
          endDate: changed.end,
          title: changed.title,
          allDay: false,
          rRule: changed.recurrenceRule,
          availabilityType: changed.availabilityType,
          exDate: changed.recurrenceExceptions ? changed.recurrenceExceptions.join(", ") : "",
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.chgAvailability(payload));
      } else if (changed.eventType === "booking") {
        // If the event being changed has recently been created and has not saved, it has a GUID for an ID and cannot be changed by the API - thus bounce it
        if (isNumeric(changed.id)) {
          duration = differenceInMinutes(new Date(changed.end), new Date(changed.start));
          var status = changed.status === "Active" || changed.status === "Attended" ? "Updated" : changed.status;
          payload = {
            id: changed.id,
            status: status,
            appointment: {
              id: changed.id,
              userTZ: "UTC", //done
              startDate: changed.start,
              duration: duration,
              clientID: changed.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              note: changed.note,
              paymentType: changed.paymentType,
              bookingType: changed.bookingType,
              bookingCode: changed.bookingCode,
              bookingLocation: changed.bookingLocation,
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          };
          dispatch(Admin.actions.putAppointment(payload));
        }
      }
    }
    // Added
    if (props.created.length > 0) {
      var added = props.created[0];
      if (
        added.title === "a" ||
        added.eventType === "availability" ||
        added.eventType === "availabilityAny" ||
        added.eventType === "availabilityExisting" ||
        added.eventType === "availabilityOther" ||
        added.eventType === "availabilitySupervision" ||
        added.eventType === "availabilityNDISContractEAP" ||
        added.eventType === "availabilityNDISContractEAPNew" ||
        added.eventType === "availabilityNDISContractEAPExisting" ||
        added.eventType === "availabilityPerinatalGriefLoss" ||
        added.eventType === "availabilityNthQLDPHNNew" ||
        added.eventType === "availabilityNthQLDPHNExisting" ||
        added.eventType === "availabilityNthQLDPHNFacetoFace" ||
        added.eventType === "availabilityCentralisedService" ||
        added.eventType === "availabilityCentralisedServiceMedicareNew" ||
        added.eventType === "availabilityCentralisedServiceSecondaryCaseConference" ||
        added.eventType === "availabilityEAPIsland"
      ) {
        // Need to determine availabilityType
        let availabilityType;
        switch (added.eventType) {
          case "availability":
            availabilityType = "Any";
            break;
          case "availabilityExisting":
            availabilityType = "Existing";
            break;
          case "availabilityOther":
            availabilityType = "Other";
            break;
          case "availabilitySupervision":
            availabilityType = "Supervision";
            break;
          case "availabilityNDISContractEAP":
            availabilityType = "NDISContractEAP";
            break;
          case "availabilityNDISContractEAPNew":
            availabilityType = "NDISContractEAPNew";
            break;
          case "availabilityNDISContractEAPExisting":
            availabilityType = "NDISContractEAPExisting";
            break;
          case "availabilityEAPIsland":
            availabilityType = "EAPIsland";
            break;
          case "availabilityPerinatalGriefLoss":
            availabilityType = "PerinatalGriefLoss";
            break;
          case "availabilityNthQLDPHNNew":
            availabilityType = "NthQLDPHNNew";
            break;
          case "availabilityNthQLDPHNExisting":
            availabilityType = "NthQLDPHNExisting";
            break;
          case "availabilityNthQLDPHNFacetoFace":
            availabilityType = "NthQLDPHNFacetoFace";
            break;
          case "availabilityCentralisedService":
            availabilityType = "CentralisedService";
            break;
          case "availabilityCentralisedServiceMedicareNew":
            availabilityType = "CentralisedServiceMedicareNew";
            break;
          case "availabilityCentralisedServiceSecondaryCaseConference":
            availabilityType = "CentralisedServiceSecondaryCaseConference";
            break;
          case "availabilityAny":
            availabilityType = "Any";
            break;
          default:
            availabilityType = "Any";
        }
        payload = {
          mainID: payloadRef.current.psychologistID,
          startDate: added.start,
          endDate: added.end,
          title: added.title,
          allDay: false,
          rRule: added.recurrenceRule,
          availabilityType: availabilityType,
          exDate: "",
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.addAvailability(payload));
      } else if (added.eventType === "booking") {
        duration = differenceInMinutes(new Date(added.end), new Date(added.start));
        payload = {
          timezone: "UTC", //done
          newbookingdate: added.start,
          duration: duration,
          clientID: added.clientID, // done
          psychologistID: payloadRef.current.psychologistID, // done
          note: added.note,
          paymentType: added.paymentType,
          bookingType: added.bookingType,
          bookingCode: added.bookingCode,
          bookingLocation: added.bookingLocation,
          refreshPayload: {
            key: "psychologist",
            id: payloadRef.current.psychologistID,
          },
          source: "ProviderPortal",
        };
        dispatch(Admin.actions.bookAppointment(payload));
      }
    }
    // Deleted
    if (props.deleted.length > 0) {
      var deleted = props.deleted[0];
      if (
        deleted.eventType === "availability" ||
        deleted.eventType === "availabilityAny" ||
        deleted.eventType === "availabilityExisting" ||
        deleted.eventType === "availabilityOther" ||
        deleted.eventType === "availabilitySupervision" ||
        deleted.eventType === "availabilityNDISContractEAP" ||
        deleted.eventType === "availabilityNDISContractEAPNew" ||
        deleted.eventType === "availabilityNDISContractEAPExisting" ||
        deleted.eventType === "availabilityPerinatalGriefLoss" ||
        deleted.eventType === "availabilityNthQLDPHNNew" ||
        deleted.eventType === "availabilityNthQLDPHNExisting" ||
        deleted.eventType === "availabilityNthQLDPHNFacetoFace" ||
        deleted.eventType === "availabilityCentralisedService" ||
        deleted.eventType === "availabilityCentralisedServiceMedicareNew" ||
        deleted.eventType === "availabilityCentralisedServiceSecondaryCaseConference" ||
        deleted.eventType === "availabilityEAPIsland"
      ) {
        payload = {
          slot: deleted.id,
          mainID: payloadRef.current.psychologistID,
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.delAvailability(payload));
      } else if (deleted.eventType === "booking") {
        dispatch(
          Admin.actions.putAppointment({
            id: deleted.id,
            status: "Cancelled",
            appointment: {
              id: deleted.id,
              userTZ: "UTC", //done
              startDate: deleted.start,
              clientID: deleted.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          }),
        );
      }
    }
  };

  const handleSchedulerDataChange = (props) => {
    if (props.deleted?.length > 0) {
      const deleted = props.deleted[0];

      if (deleted.eventType === "booking") {
        // Check if it is CS Booking
        console.log("Deleted booking:", deleted);
        if (deleted.contractId === "15") {
          // It is a CS Booking
          setAttendanceData(deleted);
          setAttendanceStatus(deleted.days);
          setShowAttendanceDialog(true);
        } else {
          // Non-CS Booking
          const client = clients.find((row) => row.id === parseInt(deleted.clientID));
          var bookingData = {
            id: deleted.id,
            clientfullname: deleted.title,
            psychologistfullname: fullName,
            psychologistDate: deleted.start,
            clientID: deleted.clientID,
            paymentType: deleted.paymentType,
            bookingType: deleted.bookingType,
            sessionType: deleted.bookingCode,
            bookingLocation: deleted.bookingLocation,
          };
          setCancellationTypeSMSText(
            `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, you were scheduled to have an appointment with Rural Health Conect. If you had problems connecting, need assistance or wish to rebook please email referrals@ruralhealthconnect.com.au or call the phone number on our wesbite.`,
          );
          setCancelBookingData(bookingData);
          // Open Provider Cancel Modal
          setShowCancelProviderBooking(true);
        }
        // IMPORTANT:
        // Do not call handleDataChange().
        // This prevents the booking from being deleted.
        return;
      }
    }

    // Everything else behaves exactly as it does currently
    handleDataChange(props);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__body" style={{ padding: 0 }}>
              <div className="kt-widget4">
                <LocalizationProvider language="en-AU">
                  <IntlProvider locale="en-AU" messages={schedulerMessages}>
                    <SchedulerLegendContainer />
                    <Scheduler
                      data={data}
                      onDataChange={handleSchedulerDataChange}
                      timezone={userTimeZone}
                      item={CustomItem}
                      defaultDate={displayDate}
                      defaultView="week"
                      editable={{
                        add: true,
                        drag: true,
                        resize: true,
                        edit: true,
                        remove: true,
                      }}
                      form={(props) => <FormWithCustomEditor {...props} psychologistId={mainID} />}
                      // header={CustomHeader}
                      height={900}
                    >
                      <DayView slotDuration={60} slotDivisions={4} />
                      <WeekView
                        title="Week"
                        workDayStart="06:00"
                        workDayEnd="22:00"
                        selectedDateFormat="{0:M}"
                        selectedShortDateFormat="{0:M}"
                        workWeekStart={Day.Monday}
                        slotDuration={60}
                        slotDivisions={4}
                      />
                      <MonthView />
                    </Scheduler>
                  </IntlProvider>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {attendanceData && attendanceData.title ? attendanceData.title : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={attendanceData && attendanceData.title ? attendanceData.title : ""}
            start={attendanceData && attendanceData.start ? attendanceData.start : null}
            end={attendanceData && attendanceData.end ? attendanceData.end : null}
            status={attendanceData && attendanceData.status ? attendanceData.status : ""}
            clientID={attendanceData && attendanceData.clientID ? attendanceData.clientID : null}
            bookingID={attendanceData && attendanceData.id ? attendanceData.id : null}
            contractId={attendanceData && attendanceData.contractId ? attendanceData.contractId : null}
            paymentType={attendanceData && attendanceData.paymentType ? attendanceData.paymentType : ""}
            psychologistID={mainID}
            attendanceStatus={attendanceStatus}
            closeModal={setShowAttendanceDialog}
            source="Calendar"
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCancelProviderBooking}
        onHide={() => setShowCancelProviderBooking(false)}
        dialogClassName="new-bookingDialog-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking with {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={3}>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "dd-MM-yyyy") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "h:mm aa") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Payment Type:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.paymentType ? cancelBookingData.paymentType : ""}
            </Grid>
            <hr />
            <Grid item md={12} xs={6}>
              <Form.Group>
                <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="NoShow"
                    type="radio"
                    checked={cancellationType === "NoShow" ? true : false}
                    onChange={(e) => setCancellationType("NoShow")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="LateCancel"
                    type="radio"
                    checked={cancellationType === "LateCancel" ? true : false}
                    onChange={(e) => setCancellationType("LateCancel")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation24"
                    type="radio"
                    checked={cancellationType === "LateCancelProvider" ? true : false}
                    onChange={(e) => setCancellationType("LateCancelProvider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation"
                    type="radio"
                    checked={cancellationType === "Provider" ? true : false}
                    onChange={(e) => setCancellationType("Provider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancelled by Provider</Form.Label>
                </Form.Check>

                {cancellationType !== "" ? (
                  <>
                    {cancellationType === "NoShow" ? (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                    ) : (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="cancellationReason"
                      value={cancellationReason}
                      onChange={(event) => setCancellationReason(event.target.value)}
                      autoComplete="new-password"
                    />
                    {cancellationType === "NoShow" ? (
                      <>
                        <Checkbox
                          aria-label="Send Cancellation SMS"
                          name="cancellationSMS"
                          value={cancellationTypeSMS}
                          onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                          style={{ paddingTop: 6, paddingLeft: 0 }}
                        />
                        <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                      </>
                    ) : null}
                    {cancellationTypeSMS ? (
                      <>
                        <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="cancellationTypeSMSText"
                          value={cancellationTypeSMSText}
                          onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                          autoComplete="new-password"
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </Form.Group>
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="warning"
                size="sm"
                onClick={() => cancelBooking(cancelBookingData && cancelBookingData.id)}
                disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                className="lightButtonOutlinedLarge"
              >
                Cancel Booking &gt;
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Modal>
    </>
  );
}
